import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import NotFound from "pages/NotFound";
import SupplierProfile from './pages/supplier-profile';
import BrowseKitchens from './pages/browse-kitchens';
import Login from './pages/login';
import SupplierDashboard from './pages/supplier-dashboard';
import CustomerDashboard from './pages/customer-dashboard';
import Register from './pages/register';
import OrderPlacement from './pages/order-placement';
import AdminDashboard from './pages/admin-dashboard';
import ForgotPassword from './pages/forgot-password';
import ResetPassword from './pages/reset-password';
import CustomerProfileEdit from './pages/customer-profile-edit';
import ShoppingCart from './pages/shopping-cart';
import MyOrders from './pages/my-orders';
import RealTimeMessaging from './pages/real-time-messaging';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<CustomerDashboard />} />
          <Route path="/browse-kitchens" element={<BrowseKitchens />} />
          <Route path="/supplier-profile" element={<SupplierProfile />} />
          <Route path="/supplier-profile/:supplierId" element={<SupplierProfile />} />
          <Route path="/login" element={<Login />} />
          <Route path="/supplier-dashboard" element={<SupplierDashboard />} />
          <Route path="/customer-dashboard" element={<CustomerDashboard />} />
          <Route path="/customer-profile-edit" element={<CustomerProfileEdit />} />
          <Route path="/register" element={<Register />} />
          <Route path="/order-placement" element={<OrderPlacement />} />
          <Route path="/shopping-cart" element={<ShoppingCart />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/my-orders" element={<MyOrders />} />
          <Route path="/real-time-messaging" element={<RealTimeMessaging />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
